<script>
export default {
  name: "ViewImagingResults",

  data() {
    return {
      active: 0,
      activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 
                rounded-t-md z-10 -mb-1`,
      inActiveClass: `bg-gray-300 border-l border-r border-t`,
      fullScreenDicom: false,
    };
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
      required: true,
    },
    imageResults: {
      type: Array,
      required: true,
    },
     externalReportingResults: {
      type: Array,
      required: true,
    },
    results: {
      type: Object,
      required: true,
    },
    investigation: {
      type: Object,
      required: true,
    },
    routeParams: {
      type: Object,
      required: true,
    },
  },

  methods: {
    printImagingResult() {
      let code = this.investigation.code || this.investigation.patientLabResultId;
      let url = `/medical-file/imaging-result/print/`;
      url += `${this.routeParams.patientID}/${code}`;

      window.open(
        url,
        "_blank",
        `LabResultPrint`,
      );
    },  printImagingImageResult() {
      let code = this.investigation.code || this.investigation.patientLabResultId;
      let url = `/medical-file/imaging-image-result/print/`;
      url += `${this.routeParams.patientID}/${code}`;

      window.open(
        url,
        "_blank",
        `LabResultPrint`,
      );
    },
  },

  components: {
    'imaging-viewer': () => import('./imaging-tabs/DicomViewer.vue'),
    'imaging-viewer-2': () => import('./imaging-tabs/OsimisViewer.vue'),
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="w-full h-screen overflow-auto">
    <template v-slot:title>
      <h5 class="font-bold text-base">Imaging Request</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap -m-3">
        <div class="w-full flex flex-wrap p-1 bg-gray-300 my-1">
          <div class="md:w-1/4 w-1/2">
            <h5 class="text-sm">
              <span class="font-medium">Accession No:</span>
              {{ investigation.code || investigation.patientLabResultId }}
            </h5>
          </div>
          <div class="md:w-1/4 w-1/2">
            <h5 class="text-sm">
              <span class="font-medium">Investigation:</span>
              {{ investigation.investigation || investigation.test }}
            </h5>
          </div>
          <div class="md:w-1/4 w-1/2">
            <h5 class="text-sm">
              <span class="font-medium">Requested By:</span>
              {{ investigation.requestedBy || `-` }}
            </h5>
          </div>
          <div class="md:w-1/4 w-1/2">
            <h5 class="text-sm">
              <span class="font-medium">Done:</span>
              {{ investigation.done ? `Yes` : `No` }}
            </h5>
          </div>
        </div>
        <ul class="flex border-b-2 border-gray-500">
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="active = 0"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active == 0 ? activeClass : inActiveClass"
              >Component Results</a
            >
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="active = 1"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active == 1 ? activeClass : inActiveClass"
              >
                <span 
                  class="p-px rounded-full text-xs text-white bg-blue-800">
                  {{ imageResults.length }}</span> Images</a>
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="active = 2"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active == 2 ? activeClass : inActiveClass"
              >Image Viewer</a>
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="active = 3"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active == 3 ? activeClass : inActiveClass"
              >Image Viewer 2</a>
          </li>
          <li class="-mb-px mr-1">
            <a
              href="javascript:void(0)"
              @click.prevent="active = 4"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 
                        font-bold whitespace-no-wrap"
              :class="active == 4 ? activeClass : inActiveClass"
              ><span 
                  class="p-px rounded-full text-xs text-white bg-blue-800">
                  {{ externalReportingResults.length }}</span>  External Reporting </a>
          </li>
        </ul>
        <div
          class="w-full overflow-auto"
          style="max-height:30rem;;"
          v-if="active == 0"
        >
          <h5 class="font-medium">Notes:</h5>
          <dl
            class="w-full"
            v-for="(detail, idx) in investigation.details"
            :key="idx"
          >
            <dt>
              <h5 class="font-medium text-sm text-blue-800">
                Date: {{ detail.sysDate | dateFormat }}
              </h5>
            </dt>
            <dd class="p-1">
              <span v-html="detail.results"></span>
              <div class="flex md:flex-row flex-col mt-2">
                <div class="flex-1">
                  <h5 class="font-medium capitalize leading-5">
                    Done By: {{ detail.analysedBy }}
                  </h5>
                </div>
                <div class="flex-1">
                  <h5 class="font-medium capitalize leading-5">
                    Requested By: {{ detail.requestedBy }}
                  </h5>
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <div class="w-full" v-if="active == 1">
          <div class="w-full flex flex-col">
            <div
              class="flex-1 p-tiny"
              v-for="(result, idx) in imageResults"
              :key="idx"
            >
              <h5 class="mb-2 font-medium text-sm capitalize">
                {{ result.comment }}
              </h5>
              <img
                :src="
                  `data:application/image;base64,${result.investigationImage}`
                "
                alt="radiology image"
              />
              <iframe
                height="1300"
                width="1400"
                :src="
                  `data:application/pdf;base64,${result.investigationImage}`
                "
              ></iframe>
            </div>
          </div>
        </div>
        <div class="w-full" v-if="active == 4">
          <div class="w-full flex flex-col">
            <div
              class="flex-1 p-tiny"
              v-for="(result, idx) in externalReportingResults"
              :key="idx"
            >
              <h5 class="mb-2 font-medium text-sm capitalize">
                {{ result.comment }}
              </h5>
              <img
                :src="
                  `data:application/image;base64,${result.investigationImage}`
                "
                alt="radiology image"
              />
              <iframe
                height="1300"
                width="1400"
                :src="
                  `data:application/pdf;base64,${result.investigationImage}`
                "
              ></iframe>
            </div>
          </div>
        </div>
        <imaging-viewer 
          :fullScreen="fullScreenDicom"
          :investigation="investigation" 
          v-if="active == 2" 
        />
        <imaging-viewer-2 
          :fullScreen="fullScreenDicom"
          :investigation="investigation" 
          v-if="active == 3"
        />
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-primary btn-sm text-xs rounded mr-8"
        @click.prevent="fullScreenDicom=!fullScreenDicom"
      ><i class="fa fa-screen"></i> 
        <span v-if="fullScreenDicom">Exit Full Screen</span>
        <span v-else> Go Full Screen</span>
      </button>
      <button
        class="btn-primary btn-sm text-xs rounded mr-8"
        @click.prevent="printImagingResult"
      ><i class="fa fa-print"></i> Print Notes
      </button>
      <button
        class="btn-primary btn-sm text-xs rounded mr-8"
        @click.prevent="printImagingImageResult"
      ><i class="fa fa-print"></i> Print Result Image
      </button>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click.prevent="$emit(`closeModal`)"
      ><i class="fa fa-times"></i> Close
      </button>
    </template>
  </tail-modal>
</template>
